import React from 'react';
import ReactDOM from 'react-dom';

import Main from 'BROWSER_TEST/main';
import recordWebrtcHistory from 'BROWSER_TEST/record_webrtc_history';
import { WEBRTC_ACTION_TYPES } from 'COMMONS/api/webrtc_history';

import deviceSupportCheck from './device_support_check';

import '../../../stylesheets/semantic-theme/definitions/modules/progress';

const hideAll = () => {
  const scenes = document.querySelectorAll('.connectivity_scene');
  scenes.forEach((scene) => {
    scene.style.display = 'none';
  });
};

const showScene = (name) => {
  hideAll();
  const scene = document.getElementById(name);
  if (scene) {
    scene.style.display = 'block';
  }
};

const startChecking = () => {
  showScene('checking_scene');

  ReactDOM.createRoot(document.getElementById('root')).render(<Main />);
};

const connectivities = () => {
  const onDOMContentLoaded = () => {
    const answerConnectivityScenes = document.getElementById('answer_connectivity_scenes');
    if (!answerConnectivityScenes) {
      return;
    }
    recordWebrtcHistory(WEBRTC_ACTION_TYPES.DISPLAY_INITIALLY);

    const showDeviceSelectDesc = document.querySelector('.js_show_device_select_desc');
    if (showDeviceSelectDesc) {
      showDeviceSelectDesc.addEventListener('click', () => {
        const deviceSelectDesc = document.getElementById('device_select_desc');
        if (deviceSelectDesc) {
          deviceSelectDesc.style.display = 'block';
        }
      });
    }

    const errors = deviceSupportCheck();
    if (errors.includes('browser')) {
      recordWebrtcHistory(WEBRTC_ACTION_TYPES.SHOW_BROWSER_NOT_SUPPORT_ERROR);
      showScene('browser_not_support_scene');
      return;
    }
    recordWebrtcHistory(WEBRTC_ACTION_TYPES.OT_CHECK_SYSTEM_REQUIREMENTS);

    if (window.location.hash === '#skip_intro') {
      startChecking();
    } else {
      const startDeviceChecking = document.getElementById('start_device_checking');
      if (startDeviceChecking) {
        startDeviceChecking.addEventListener('click', () => {
          recordWebrtcHistory(WEBRTC_ACTION_TYPES.CLICK_START_BUTTON);
          startChecking();
        });
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onDOMContentLoaded);
  } else {
    onDOMContentLoaded();
  }
};

export default connectivities;
